import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import FilePickerStore from './schema/FilePickerStore';
import { createStore } from 'satcheljs';
import { FilePickerPreloadState } from './schema/FilePickerPreloadState';
import { FilePickerViewType } from '../types/FilePickerViewSwitcher';
import { FileSelectionFilter } from 'owa-fileprovider-store';

const filePickerStoreData: FilePickerStore = {
    viewState: {
        isOpen: false,
        preloadState: FilePickerPreloadState.NotLoaded,
        fileSelectionFilter: FileSelectionFilter.None,
        selectedFileProvider: null,
        selectedProviderScope: null,
        filePickerViewState: {
            breadcrumbs: [],
            columnSorting: null,
            fileProviderItems: [],
            isLoadingItems: false,
            pagingMetadata: null,
            selectedFileProviderItems: [],
            selectedFolder: null,
            selectedView: null,
            supportedActions: [],
            supportedActionsMessages: [],
            supportedViews: [],
            totalItemsCount: 0,
            userPreferredViewType: FilePickerViewType.List,
            searchViewState: {
                searchQuery: '',
                isInSearchMode: false,
            },
            filterOptionsState: {
                showFilterOptions: false,
                selectedFilterOption: AttachmentItemsFilterBy.None,
            },
        },
        filePickerErrorMessageViewState: {
            isShown: false,
            message: null,
        },
        filePickerActionsViewState: {
            isOpen: false,
            saveUserChoice: false, // related to the "remember my choice" checkbox in the actions panel
            isCalloutVisible: false, // callout for the checkbox
            uploadConfiguration: null,
        },
        showFileProviderInlineView: false,
    },
};

const getFilePickerStore = createStore<FilePickerStore>('filepicker', filePickerStoreData);
export { getFilePickerStore };
